import type { ExpirationOption } from './expiration';

export interface SecurityPrivacySettings {
  maskSensitiveHeaders: boolean;
  confirmBeforeSharing: boolean;
}

export interface ShareBehaviorSettings {
  defaultShareFormat: 'link' | 'text';
  includeHeaders: boolean;
  includeResponseData: boolean;
  includeRequestBody: boolean;
  includeQueryParameters: boolean;
}

export interface ExpirationSettings {
  defaultExpiration: ExpirationOption;
}

export interface AppearanceSettings {
  theme: 'system' | 'light' | 'dark';
  codeFormat: 'pretty' | 'raw';
}

export interface UserPreferences {
  security: SecurityPrivacySettings;
  sharing: ShareBehaviorSettings;
  expiration: ExpirationSettings;
  appearance: AppearanceSettings;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  security: {
    maskSensitiveHeaders: true,
    confirmBeforeSharing: true,
  },
  sharing: {
    defaultShareFormat: 'link',
    includeHeaders: true,
    includeResponseData: true,
    includeRequestBody: true,
    includeQueryParameters: true,
  },
  expiration: {
    defaultExpiration: '24h',
  },
  appearance: {
    theme: 'system',
    codeFormat: 'pretty',
  },
};
